import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  Button,
  CardTitle,
  Input,
  FormFeedback,
  UncontrolledTooltip,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, useHistory, Link, useParams } from "react-router-dom";

// Backend
import { getProductList, getCauseList } from "connection/backend";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

// actions
import { confiscationCreate } from "store/actions";

const ConfiscationCreate = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const redirect = () => {
    history.push("/confiscations");
  };

  const [products, setProducts] = useState([]);

  const getProductData = async () => {
    const response = await getProductList();
    const data = response.data;
    setProducts(data);
  };

  useEffect(() => {
    getProductData();
  }, []);

  const [formData, setFormData] = useState([
    { ticket: id, product: "", cause: "", quantity: 1, causes: [] },
  ]);

  const getCauseData = async (product_name, product_id, idx) => {
    const response = await getCauseList(`?product=${product_id}`);
    const data = response.data.results;
    const newData = [...formData];
    if (product_id === "") {
      newData[idx] = {
        ...newData[idx],
        [product_name]: product_id,
        causes: [],
      };
    } else {
      newData[idx] = {
        ...newData[idx],
        [product_name]: product_id,
        causes: data,
      };
    }
    setFormData(newData);
  };

  const onChange = (e, idx) => {
    getCauseData(e.target.name, e.target.value, idx);
  };

  const onChange1 = (e, idx) => {
    const newData = [...formData];
    if (e.target.name === "quantity") {
      newData[idx] = {
        ...newData[idx],
        [e.target.name]: e.target.value === "" ? 1 : parseInt(e.target.value),
      };
    } else {
      newData[idx] = { ...newData[idx], [e.target.name]: e.target.value };
    }
    setFormData(newData);
  };

  const onAdd = () => {
    setFormData([
      ...formData,
      { ticket: id, product: "", cause: "", quantity: 1, causes: [] },
    ]);
  };

  const onDelete = (idx) => {
    const newData = [...formData];
    newData.splice(idx, 1);
    setFormData(newData);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const finalData = formData.map((confiscation) => {
      const { causes, ...finalData } = confiscation;
      return finalData;
    });
    dispatch(confiscationCreate(finalData));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Decomisos </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Decomisos"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              {props.confiscationCreated.length > 0 ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  La lista de decomisos se ha registrado correctamente.
                </SweetAlert>
              ) : null}
              <Card
                style={{
                  width: "70rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">
                    Generar lista de decomisos
                  </h2>
                </CardTitle>
                <CardBody>
                  <Row className="justify-content-md-center">
                    <Col lg={3}>
                      <Label>
                        <b>PRODUCTO</b>
                      </Label>
                    </Col>
                    <Col lg={3}>
                      <Label>
                        <b>CAUSA</b>
                      </Label>
                    </Col>
                    <Col lg={1}>
                      <Label>
                        <b>CANT</b>
                      </Label>
                    </Col>
                    <Col lg={2}>
                      <Label>
                        <b>ACCIÓN</b>
                      </Label>
                    </Col>
                  </Row>
                  <Form onSubmit={onSubmit}>
                    {formData.map((data, idx) => (
                      <Row className="justify-content-md-center mb-3" key={idx}>
                        <Col lg={3}>
                          <Input
                            type="select"
                            id="product"
                            name="product"
                            value={data.product}
                            onChange={(e) => onChange(e, idx)}
                            required
                          >
                            <option value="">Seleccione un producto...</option>
                            {products.map((prod, idx) => (
                              <option key={idx} value={prod.id}>
                                {prod.name}
                              </option>
                            ))}
                          </Input>
                        </Col>
                        <Col lg={3}>
                          <Input
                            type="select"
                            id="cause"
                            name="cause"
                            value={data.cause}
                            onChange={(e) => onChange1(e, idx)}
                            required
                          >
                            <option value="">Seleccione una causa...</option>
                            {data.causes.map((caus, idx) => (
                              <option key={idx} value={caus.id}>
                                {caus.name}
                              </option>
                            ))}
                          </Input>
                        </Col>
                        <Col lg={1}>
                          <Input
                            type="number"
                            name="quantity"
                            id="quantity"
                            value={data.quantity}
                            min={1}
                            onChange={(e) => onChange1(e, idx)}
                          />
                        </Col>
                        {idx < formData.length - 1 ? (
                          <Col lg={2}>
                            <Button
                              color="secondary"
                              onClick={() => onDelete(idx)}
                            >
                              Borrar
                            </Button>
                          </Col>
                        ) : (
                          <Col lg={2}>
                            <Button color="primary" onClick={onAdd}>
                              Agregar
                            </Button>
                          </Col>
                        )}
                      </Row>
                    ))}
                    <Row className="justify-content-md-center mt-4 ms-5">
                      <Col lg={3}>
                        <Link
                          className="btn btn-danger me-4"
                          to="/confiscations"
                        >
                          Cancelar
                        </Link>

                        <Button color="success" type="submit">
                          Crear
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, confiscationCreated } = state.Billing;
  return { error, loading, confiscationCreated };
};

export default withRouter(connect(mapStateToProps)(ConfiscationCreate));
